module.exports = __webpack_public_path__ + "assets/img/img-hotel-01.5944d2a7.jpg";